import { ValidationProps, ValidationLevel } from 'ui/common/validation/types';
import { SubscriberGroupsTranslation } from 'app/area/subscriber-groups/constants';

export interface ValidationData {
  id: number;
  reassignReferencesToCodeId: number;
  translation: SubscriberGroupsTranslation;
}

export const validate = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { id, reassignReferencesToCodeId, translation } = validationData;

  return id === reassignReferencesToCodeId
    ? {
      reassignReferencesToCode: {
        level: ValidationLevel.error,
        messages: [
          { parameters: {}, level: ValidationLevel.error, message: translation.deleted_code_validation }
        ]
      }
    } : undefined;
};
